export const ar = {

    upload_max_file : 'يمكنك تحميل 3 ملفات كحد أقصى.',
    upload_message : 'اسحب الملف هنا أو <em>انقر للتحميل.</em>',
    upload_tip_1 : 'يمكنك فقط تحميل الملفات بصيغة doc و docx و pdf.',


    notification_warning_title: 'انتباه!',
    notification_destroy: 'البيانات التي اخترتها سيتم حذفها نهائياً. هل تؤكد؟',
    notification_destroy_cancel: 'تم إلغاء عملية الحذف.',
    notification_sending_cancel: 'تم إلغاء عملية الإرسال.',
    notification_reCaptchaTitle: 'أنا لست روبوت',

    dialog_file_upload_title: 'تحميل ملف',
    dialog_file_upload_description: 'طباعة خالية من المتاعب وجودة تصنيع عالية',
    dialog_offer_title: 'طلب عرض سعر',
    dialog_offer_description: 'طباعة خالية من المتاعب وجودة تصنيع عالية',

    misc_or: 'أو',
    misc_yes: 'نعم',
    misc_no: 'لا',
    misc_search_not_found: 'عذراً، لم يتم العثور على نتائج تطابق بحثك.',

    inputs_choice: 'اختيارك',
    inputs_your_message: 'رسالتك...',
    inputs_your_email: 'عنوان بريدك الإلكتروني',
    inputs_email: 'البريد الإلكتروني',
    inputs_first_name: 'الاسم الأول',
    inputs_last_name: 'اسم العائلة',
    inputs_your_phone: 'رقم هاتفك',
    inputs_phone: 'الهاتف',
    inputs_country: 'البلد',
    inputs_city: 'المدينة',
    inputs_town: 'المنطقة/المقاطعة',
    inputs_subject: 'الموضوع',
    inputs_message: 'الرسالة',
    inputs_your_full_name: 'اسمك بالكامل',
    inputs_full_name: 'الاسم الكامل',
    inputs_has_access_web_site: 'أسمح بنشرها على الموقع الإلكتروني.',

    button_send: 'إرسال',
    button_save: 'حفظ',
}
